module.exports = __webpack_public_path__ + "static/Dive-7d7f7b9b344f7052a483180892de515a.png";